module.exports = __webpack_public_path__ + "img/jellybean_spark.f6e41a59.png";